// extracted by mini-css-extract-plugin
module.exports = {"bigFontSize":"Utility-module--bigFontSize--1WaEI","biggerFontSize":"Utility-module--biggerFontSize--3EyQg"};